import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
import Head from "next/head";
import AppbarIndustry from "../../../../components/AppbarIndustry";
import HeroSection from "../../../../components/HeroSection";
import TitleIndustry from "../../../../components/TitleIndustry";
import HeroEnquiryFormIndustry from "../../../../components/HeroEnquiryFormIndustry";
import FooterIndustry from "../../../../components/FooterIndustry";
import { ourProducts } from "../../../../components/chemical/data";
import StickyWhatsappIndustries from "../../../../components/StickyWhatsappIndustries";

function PlanningSoftware() {
  const products = [
    
    "Process Safety Management Software",
    

  ];
  const data = {
    image: "/industries/chemical/process-safety-management-software.jpg", // Replace with the appropriate image URL
    intro: `Introduce Process Safety Management Software, a comprehensive solution designed to ensure the safety and integrity of chemical processes, reducing the risk of accidents and incidents.`,
    keyFeatures: [
        {
            title: "Hazard identification and analysis tools",
            content: "Utilize tools for the identification and analysis of potential hazards in chemical processes.",
        },
        {
            title: "Risk assessment and mitigation planning",
            content: "Facilitate risk assessment and planning for effective mitigation strategies to enhance process safety.",
        },
        {
            title: "Incident reporting and investigation modules",
            content: "Provide modules for incident reporting and thorough investigation to learn from and prevent future incidents.",
        },
        {
            title: "Compliance tracking with safety regulations",
            content: "Track and ensure compliance with safety regulations governing chemical processes.",
        },
        {
            title: "Emergency response planning and simulation",
            content: "Develop and simulate emergency response plans to enhance preparedness for potential incidents.",
        },
    ],
    howItWorks: `Explain how the software facilitates the identification of potential hazards, assesses and mitigates risks, and ensures a proactive approach to incident management and emergency response.`,
    benefits: {
        title: "The benefits of Process Safety Management Software",
        data: [
            "Enhanced process safety and integrity.",
            "Reduction in the risk of accidents and incidents.",
            "Compliance with safety regulations.",
            "Improved emergency preparedness.",
        ],
    },
    industries: "Critical for chemical manufacturing, processing, and industries dealing with potentially hazardous materials.",
    stories: `Highlight instances where the software has played a crucial role in preventing incidents, ensuring process safety, and maintaining regulatory compliance.`,
    contactUs: `Provide contact information for inquiries and support related to Process Safety Management Software.`,
    futureDevelopments: `Discuss upcoming features and innovations in process safety management technology, emphasizing continuous improvement and staying ahead of safety standards.`,
    technology: `Explore how the software seamlessly integrates with existing process control systems, safety instruments, and emergency response tools.`,
    support: `Offer resources for user training and support to ensure effective utilization of Process Safety Management Software.`,
    industry: `Explain how the software adheres to industry standards and regulatory requirements governing process safety in the chemical industry.`,
    events: "Keep users informed about industry events and potential collaborations in the realm of process safety management for the chemical industry.",
    blog: `Provide a platform for articles, case studies, and expert insights in a blog and knowledge hub dedicated to best practices in process safety management.`,
    careers: `Invite individuals to explore career opportunities contributing to the development and enhancement of Process Safety Management Software. Join us in ensuring the highest standards of process safety in the chemical industry.`,
};

  
  
  
  
  
  
  
  
  const content = "Embark on a chemical innovation journey with us! Whether you're delving into chemical technology, process optimization, sustainability solutions, or any facet of the chemical industry, we offer tailored solutions. Our expertise spans projects of various scales, ensuring our chemical solutions align seamlessly with your goals, budget, and scope."
    return (
    <>
     <Head>
        
<title>Process Safety Management Software</title>
<meta name="description" content="Discover our industry-leading process safety management software designed to optimize safety procedures, mitigate risks, and ensure regulatory compliance in chemical processes. Explore cutting-edge technology for effective process safety management." />
<Head>
    <title>Process Safety Management Software | Enhance Safety Standards | Techbrain Networks</title>
    <meta name="description" content="Elevate safety standards with Techbrain Networks Process Safety Management Software. Streamline safety procedures and risk management in chemical manufacturing." />
    <meta name="keywords" content="process safety management, safety software, chemical manufacturing, risk management, Techbrain Networks" />
    <meta property="og:title" content="Process Safety Management Software | Enhance Safety Standards | Techbrain Networks" />
    <meta property="og:description" content="Techbrain Networks offers Process Safety Management Software designed to improve safety protocols and risk management in chemical industries." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.techbrainnetworks.com/industries/chemical/products/process-safety-management-software" />
    <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta property="og:image:alt" content="Process Safety Management Software" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Process Safety Management Software | Enhance Safety Standards" />
    <meta name="twitter:description" content="Improve safety standards with Techbrain Networks Process Safety Management Software, designed for chemical manufacturing and risk management." />
     <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpgg" />
    <link rel="canonical" href="https://www.techbrainnetworks.com/industries/chemical/products/process-safety-management-software" />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Process Safety Management Software",
        "image": "https://www.techbrainnetworks.com/logo-tbn.jpg",
        "description": "Elevate safety standards with Techbrain Networks Process Safety Management Software, enhancing safety procedures in chemical manufacturing.",
        "brand": "Techbrain Networks",
        "offers": {
            "@type": "Offer",
            "url": "https://www.techbrainnetworks.com/industries/chemical/products/process-safety-management-software",
            "priceCurrency": "USD",
            "price": "Contact for pricing"
        }
    })}} />
</Head>
<link rel="icon" href="/favicon.png" />
      </Head>
      <AppbarIndustry title={"Chemical"} homeLink={'/industries/chemical'} link={'/industries/chemical/products'} />
      <StickyWhatsappIndustries link={"https://api.whatsapp.com/send?phone=918754906714"}  color={"#673bbf"} />
      <HeroSection img={'/industries/chemical/process-safety-management-software.jpg'}>
        Process Safety Management Software
         </HeroSection>
      <Box
        sx={{
          px: [0, "1.2rem", "3.8rem", "3rem"],
          pb: [1, 1, 2, 2, 4],
          bgcolor: "#04010a",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {/* intro */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",

            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#673bbf"}>Introduction</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.intro}
          </Typography>
        </Box>
        {/* Key Features Unleashed */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", ".5rem", "1.5rem", "1.5rem", "1rem"],
          }}
        >
          <TitleIndustry color={"#673bbf"}>Key Features Unleashed</TitleIndustry>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: ["column", "row"],
              flexWrap: "wrap",
              justifyContent: [null, "space-between", "flex-start"],
              gap: ["2rem", "1rem", "2rem", "2rem", "2rem"],
            }}
          >
            {data.keyFeatures.map((i, k) => (
              <Box
                sx={{
                  display: "flex",
                  width: ["95%", "45%", "30%"],
                  flexDirection: "column",
                  gap: ["0.5rem", "0.5rem", "0.5rem", "0.5rem", "1rem"],
                }}
              >
                <Typography
                  sx={{
                    fontSize: [
                      "1.3rem",
                      "1.2rem",
                      "1.2rem",
                      "1.4rem",
                      "1.5rem",
                    ],
                    fontWeight: "bold",
                    color: "#673bbf",
                  }}
                >
                  {i.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {i.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        {/* how it works */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#673bbf"}>How It Works?</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.howItWorks}
          </Typography>
        </Box>
        {/* benefits */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", "1.5rem", ".5rem"],
          }}
        >
          <Stack
            direction={"column"}
            sx={{
              width: ["100%", "48%"],
            }}
          >
            <TitleIndustry color={"#673bbf"}>Benefits</TitleIndustry>
            <Typography
              sx={{
                fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                color: "#fff",
              }}
            >
              {data.benefits.title}:
            </Typography>

            <Stack
              direction={"column"}
              sx={{
                gap: [1, 1, 2],
                mt: [3, 3, 4],
              }}
            >
              {data.benefits.data.map((i, k) => (
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {"•  "}
                  {i}
                </Typography>
              ))}
            </Stack>
          </Stack>

          <Box
            sx={{
              width: ["100%", "50%", "45%"],
              height: ["20rem", "20rem", "20rem", "25rem", "30rem"],
              backgroundImage: `url(${data.image})`,
              backgroundposition: "center",
              backgroundSize: "cover",
              backgroundrepeat: "no-repeat",
              borderRadius: "16px",
            }}
          />
        </Stack>
          {/* Industries */}
          <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#673bbf"}>Industries</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industries}
          </Typography>
        </Box>

        

        {/* Future Developments and Innovations*/}
 
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#673bbf"}>Future Developments and Innovations</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
           Stay informed about upcoming features and innovations in electronic countermeasure planning technolog.

          </Typography>
        </Box>

        {/* Technology Integration */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#673bbf"}>Technology Integration</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.technology}
          </Typography>
        </Box>

        {/* User Training and Support */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#673bbf"}>User Training and Support</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.support}
          </Typography>
        </Box>

        {/*  Industry Standards and Compliance */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#04010a",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#673bbf"}> Industry Standards and Compliance</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industry}
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
          
            display: "flex",
            gap: "1rem",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: ["2rem", "3rem", "3rem", "4rem"],
                fontWeight: "bold",
                color: "#673bbf",
                textAlign: "center",
              }}
            >
              Contact
            </Typography>
          </Box>
          <Box
            sx={{
              width: [ "100%"],
              display: "flex",
              justifyContent: "center",
              padding:'1rem'
            }}
          >
            <HeroEnquiryFormIndustry color={"#673bbf"} products={products} content={content}/>
          </Box>
        </Box>
      </Box>
      <FooterIndustry ourProducts={ourProducts} color={"#673bbf"} bg={"#04010a"} />
    </>
  );
}

export default PlanningSoftware;
